import store from '@/store';
import { VolumeUnits } from 'pando-constants';

export default function preferredVolumeUnit(config) {
  const clientConfigurations = config || store.getters['app/currentClientConfig'];
  const clientRequestedUnit = (clientConfigurations && clientConfigurations.preferred_volume_unit)
    ? clientConfigurations.preferred_volume_unit : VolumeUnits.CFT;
  return clientRequestedUnit;
}
